<template>
    <v-container>
        <v-card>
            <v-toolbar flat color="#1d2735" dark>
                <v-toolbar-title
                    >Guardar / Editar Factura
                    {{ tipo == 2 ? "Proforma" : "" }}</v-toolbar-title
                >
            </v-toolbar>
            <v-card-text>
                <v-form ref="form">
                    <div class="font-weight-bold mb-3 black--text">
                        DATOS DEL CLIENTE Y FECHA
                    </div>
                    <v-row align="center">
                        <!-- <v-col cols="12" md="2" v-if="$route.query.id">
                            <v-text-field
                            dense
                            outlined
                            label="Nro"
                            v-model="nro_factura"
                            ></v-text-field>
                        </v-col> -->
                        <v-col cols="12" md="4">
                            <v-autocomplete
                                dense
                                outlined
                                v-model="id_cliente"
                                :items="usuarios"
                                item-value="id"
                                item-text="nombres"
                                label="Cliente"
                                :rules="[rules.required]"
                                :readonly="$route.query.id ? true : false"
                            ></v-autocomplete>
                        </v-col>
                        <!-- v-col cols="12" md="4">
                        <v-autocomplete dense outlined v-model="id_proyecto" :items="proyectos" item-value="id" item-text="nombre" label="Proyecto"></v-autocomplete>
                        </>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="cliente" outlined dense label="Cliente"></v-text-field>
                        </v-col> -->
                        <v-col cols="12" md="4">
                            <v-menu
                                v-model="menu2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                :disabled="guardado ? true : false"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="fecha"
                                        outlined
                                        dense
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="fecha"
                                    @input="menu2 = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <!-- <v-col cols="12" md="2">
                            <v-checkbox
                                v-model="kit"
                                label="¿Es kit?"
                                :readonly="guardado ? true : false"
                            ></v-checkbox>
                        </v-col> -->
                        <v-col cols="12" md="2">
                            <v-checkbox
                                v-model="enviado_cliente"
                                label="Enviado al cliente"
                                :readonly="guardado ? true : false"
                            ></v-checkbox>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field
                                dense
                                outlined
                                v-model="nombre_cliente"
                                label="Nombre fiscal"
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                dense
                                outlined
                                :rules="[rules.cifOrDni]"
                                v-model="cif_cliente"
                                label="CIF/DNI"
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                dense
                                outlined
                                v-model="domicilio"
                                label="Domicilio"
                                readonly
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-textarea
                                outlined
                                label="Descripcion-notas"
                                v-model="notas"
                                :readonly="guardado ? true : false"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-form>

                <div class="font-weight-bold mb-3 black--text">
                    DATOS DEL SERVICIO A FACTURAR
                </div>
                <v-row>
                    <v-col cols="12" md="3">
                        <v-textarea
                            v-model="description"
                            outlined
                            dense
                            label="Descripcion"
                            rows="1"
                            auto-grow
                            row-height="15"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field
                            type="number"
                            v-model="quantity"
                            outlined
                            dense
                            label="Cantidad"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field
                            type="number"
                            v-model="price"
                            outlined
                            dense
                            label="Precio"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-select
                            v-model="id_iva"
                            :items="ivas"
                            item-value="id"
                            item-text="descripcion"
                            outlined
                            dense
                            suffix="%"
                            label="IVA"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field
                            type="number"
                            v-model="imp"
                            outlined
                            dense
                            label="Importe"
                            readonly
                        ></v-text-field>
                    </v-col>
                </v-row>
                <div class="mb-5">
                    <v-btn
                        v-if="editing == null"
                        @click="HandlerAdd()"
                        color="primary"
                        class="white--text"
                        rounded
                        :disabled="guardado ? true : false"
                    >
                        Agregar servicio
                    </v-btn>
                    <v-btn
                        v-else
                        @click="HandlerAdd()"
                        color="primary"
                        class="white--text"
                        rounded
                        :disabled="guardado ? true : false"
                    >
                        Actualizar servicio
                    </v-btn>
                    <v-btn
                        @click="LimpiarServicio()"
                        color="red"
                        class="white--text"
                        rounded
                        :disabled="guardado ? true : false"
                    >
                        Limpiar servicio
                    </v-btn>
                </div>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="items"
                    disable-pagination
                    hide-default-footer
                    class="elevation-1"
                >
                    <template v-slot:item.descripcion="{ item }">
                        <p class="pre-wrap">{{ item.descripcion }}</p>
                    </template>
                    <template v-slot:item.iva="{ item }">
                        {{
                            ivas.find((iva) => iva.id === item.id_iva)
                                ?.descripcion
                        }}%
                    </template>
                    <template v-slot:item.precio="{ item }">
                        {{ item.precio | format_precio }}
                    </template>
                    <template v-slot:item.importe="{ item }">
                        {{ item.importe | format_precio }}
                    </template>
                    <template v-slot:item.action="{ item }" v-if="!guardado">
                        <!-- <v-icon @click="edit(item)" color="blue">mdi-pencil</v-icon> -->
                        <v-icon @click="editItem(item)" color="primary"
                            >mdi-pencil</v-icon
                        >
                        <v-icon @click="deleteItem(item)" color="red"
                            >mdi-delete</v-icon
                        >
                    </template>
                </v-data-table>

                <div class="font-weight-bold mb-3 black--text my-3">
                    DESCUENTOS Y TOTALES
                </div>
                <v-row justify="space-between">
                    <v-col cols="12" md="4">
                        <v-text-field
                            type="numeric"
                            v-model="desc"
                            outlined
                            dense
                            label="Descuento %"
                            @input="calcularTotales()"
                            :readonly="guardado ? true : false"
                        ></v-text-field>
                        <dynamic_select
                            v-bind:estados="retenciones"
                            show="descripcion"
                            title="Retención"
                            outlined
                            :dense="true"
                            v-model="id_retencion"
                            @create="createRetencion"
                            @delete="deleteRetencion"
                            @getEstado="updateRetencionS"
                            @update="updateRetencion"
                        >
                            <v-text-field
                                label="Descripción"
                                v-model="retencion.descripcion"
                                suffix="%"
                            ></v-text-field>
                        </dynamic_select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-autocomplete
                            dense
                            outlined
                            v-model="cuenta"
                            :items="cuentas"
                            item-value="id"
                            item-text="nombre_banco"
                            label="Banco"
                            readonly
                        ></v-autocomplete>
                        <v-autocomplete
                            dense
                            outlined
                            v-model="cuenta"
                            :items="cuentas"
                            item-value="id"
                            item-text="cuenta"
                            label="Cuenta bancaria"
                            :readonly="guardado ? true : false"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-card class="px-2 py-2">
                            <span class="font-weight-bold"
                                >Sub Total:
                                {{ subTotal() | format_precio }}</span
                            ><br />
                            <span class="font-weight-bold"
                                >Descuento:
                                {{ descuento() | format_precio }}</span
                            ><br />
                            <!-- <span class="font-weight-bold"
                                >Iva:
                                {{
                                    parseFloat(HandlerIva(false)).toFixed(2)
                                }}€</span
                            ><br /> -->
                            <template v-for="(item, index) in totales_ivas">
                                <span
                                    class="font-weight-bold"
                                    v-bind:key="index"
                                >
                                    {{ item.titulo }}:
                                    {{ item.value | format_precio }}
                                </span>
                                <br />
                            </template>
                            <span class="font-weight-bold"
                                >Retención: -{{
                                    HandlerRetencion() | format_precio
                                }}</span
                            ><br />
                            <span class="font-weight-bold"
                                >Total: {{ total | format_precio }}</span
                            >
                        </v-card>
                    </v-col>
                </v-row>
                <!-- <v-row>
                    <v-checkbox
                        label="incluir IVA 21%"
                        color="primary"
                        v-model="incl_iva"
                        @change="HandlerIva(true)"
                        :readonly="guardado ? true : false"
                    ></v-checkbox>
                </v-row> -->
            </v-card-text>
        </v-card>

        <!-- Botones Navegacion -->
        <v-row class="mt-3">
            <v-col cols="12">
                <!-- Volver -->
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            @click="
                                $router.push(
                                    tipo == 1
                                        ? '/lista-facturas'
                                        : '/lista-facturas-pro'
                                )
                            "
                            :loading="isloading"
                            :disabled="isloading"
                            color="blue"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text"
                                >mdi-arrow-left-bold-outline</v-icon
                            >
                        </v-btn>
                    </template>
                    <span>Volver</span>
                </v-tooltip>

                <!-- Guardar -->
                <!-- <v-tooltip top v-if="!guardado"> -->
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            @click="guardarFactura()"
                            :loading="isloading"
                            :disabled="isloading"
                            color="success"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text"
                                >mdi-content-save-all</v-icon
                            >
                        </v-btn>
                    </template>
                    <span>Guardar Factura</span>
                </v-tooltip>

                <!-- Duplicar -->
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            v-if="$route.query.id != null"
                            @click="duplicarFactura()"
                            :loading="isloading"
                            :disabled="isloading"
                            color="success"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
                                />
                            </svg>
                        </v-btn>
                    </template>
                    <span>Duplicar</span>
                </v-tooltip>

                <!-- Cambiar tipo -->
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            v-if="$route.query.id != null && tipo == 2"
                            @click="ChangeFactura()"
                            :loading="isloading"
                            :disabled="isloading"
                            color="success"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                                />
                            </svg>
                        </v-btn>
                    </template>
                    <span>Cambiar Tipo</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <ProyectosSinFacturarDialog
            v-model="dialog_proyectos"
            :id_cliente="id_cliente"
        ></ProyectosSinFacturarDialog>

        <v-dialog v-model="isAlertDialogVisible" max-width="500">
            <v-card>
                <v-card-title class="text-h5 dialog-title">Aviso</v-card-title>
                <v-card-text class="mt-2">
                    <h4>Este proyecto tiene los siguientes gastos externos:</h4>
                    <v-list>
                        <v-list-item
                            v-for="item in gastos_externos"
                            :key="item.id"
                        >
                            <v-list-item-content>
                                <v-list-item-title
                                    class="d-flex justify-space-between"
                                >
                                    <span>{{ item.titulo }}</span>
                                    <span>{{
                                        item.importe | format_precio
                                    }}</span>
                                </v-list-item-title>
                                <v-list-item-subtitle>{{
                                    item.descripcion
                                }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-card-actions class="d-flex justify-center">
                    <v-btn @click="isAlertDialogVisible = false" color="success"
                        >Ok</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
// import { parseArgs } from "util";
import { rules } from "../../../utils/rules";
import ProyectosSinFacturarDialog from "./ProyectosSinFacturarDialog.vue";
import DynamicSelect from "../../../components/general/DynamicSelect.vue";
export default {
    components: {
        ProyectosSinFacturarDialog,
        DynamicSelect,
    },
    setup() {
        return {
            rules: rules,
        };
    },
    data() {
        return {
            // Variables generales
            dialog_proyectos: false,
            menu2: false,
            iva: parseFloat(0).toFixed(2),
            usuarios: [],
            proyectos: [],
            retenciones: [],
            ivas: [],
            cuentas: [],
            cliente: {},
            guardado: false,
            isAlertDialogVisible: false,
            gastos_externos: [],

            // headers de la tabla de servicios a facturar
            headers: [
                { text: "Descripcion", value: "descripcion", sortable: false },
                { text: "Cantidad", value: "cantidad", sortable: false },
                { text: "Precio", value: "precio", sortable: false },
                { text: "Iva", value: "iva", sortable: false },
                { text: "Importe", value: "importe", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],

            // Factura
            id: 0,
            id_retencion: null,
            id_proyecto: null,
            total: parseFloat(0).toFixed(2),
            desc: 0,
            fecha: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            cuenta: 2,
            items: [],
            incl_iva: true,
            nro_factura: 0,
            tipo: 1,
            id_cliente: null,
            nombre_cliente: "",
            cif_cliente: "",
            domicilio: "",
            notas: "",
            kit: false,
            enviado_cliente: false,

            // se usa al guardar la factura para eliminar items
            id_items_factura: [],

            // Editar servicio a facturar
            editing: null,
            description: "",
            quantity: 0,
            price: parseFloat(0).toFixed(2),
            imp: parseFloat(0).toFixed(2),
            id_iva: null,
            retencion: {
                id: null,
                descripcion: "",
            },
            totales_ivas: [],
        };
    },
    created() {
        this.getActiveClientes();
        this.getAllCuentas();
        this.getRetenciones();
        this.getIvas();

        if (this.$route.path == "/registrr-facturas-pro") {
            this.tipo = 2;
        }
        if (this.$route.query.cliente != null) {
            this.id_cliente = parseInt(this.$route.query.cliente);
        }
        if (this.$route.query.id_proyecto != null) {
            this.id_proyecto = parseInt(this.$route.query.id_proyecto);
            this.getProyectoById(this.id_proyecto);
        }
        if (this.$route.query.id != undefined && this.$route.query.id != null) {
            this.getFacturaId(this.$route.query.id);
        }
    },
    watch: {
        id_cliente: async function (val) {
            await this.getProyectosByUser(val, 0);
            this.getCliente();
        },
        quantity(n) {
            this.imp = parseFloat(n * this.price).toFixed(2);
        },
        price(n) {
            this.imp = parseFloat(n * this.quantity).toFixed(2);
        },
        id_iva(n) {
            const iva = this.ivas.find((iva) => iva.id === n);
            this.imp = parseFloat(
                this.price * this.quantity * (1 + iva?.descripcion / 100)
            ).toFixed(2);
        },
        id_retencion(n) {
            this.calcularTotales();
        },
    },
    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        errors() {
            return this.$store.getters.geterrors;
        },
    },
    methods: {
        // Acciones de factura
        async getFacturaId(id) {
            try {
                const response = await axios.get(`api/show-facturas/${id}`);
                this.nro_factura = response.data.nro_factura;
                this.items = response.data.items_factura;
                this.id_proyecto = response.data.id_proyecto;
                this.desc = response.data.descuento;
                this.incl_iva = response.data.status_iva;
                this.subTotal();
                this.cuenta = response.data.id_cuenta;
                this.notas = response.data.notas;
                this.id_cliente = response.data.id_cliente;
                this.kit = response.data.kit;
                this.enviado_cliente = response.data.enviado;
                this.id_retencion = response.data.id_retencion;

                // comprueba si la relacion de factura con cliente no es nula
                if (response.data.cliente != null) {
                    // y establece los datops del cliente segun sus columnas de la tabla,
                    // en caso de ser nulos, los establece con los dastos de la relacion
                    this.nombre_cliente =
                        response.data.nombre_cliente ??
                        response.data.cliente.nombre_fiscal;
                    this.cif_cliente =
                        response.data.cif_cliente ?? response.data.cliente.cif;

                    let provincia = "";
                    if (response.data.cliente.provincia != null) {
                        provincia = response.data.cliente.provincia.nombre;
                    }

                    const domicilio =
                        (response.data.cliente.direccion ?? "") +
                        (response.data.cliente.codigo_postal != null
                            ? "-- C.P."
                            : "") +
                        (response.data.cliente.codigo_postal ?? "") +
                        " " +
                        (response.data.cliente.localidad ?? "") +
                        " " +
                        provincia;

                    this.domicilio = response.data.domicilio ?? domicilio;
                } else {
                    this.nombre_cliente = response.data.nombre_cliente;
                    this.cif_cliente = response.data.cif_cliente;
                    this.domicilio = response.data.domicilio;
                }

                this.guardado = this.enviado_cliente ? true : false;

                if (response.data.id_cliente == null) {
                    this.id_cliente = response.data.cliente_real.id;
                }
                //this.getProyectoById(this.id_proyecto)
                // this.calcula_total();
                this.calcularTotales();
                this.fecha = response.data.fecha;
            } catch (error) {
                console.log(error);
            }
        },
        async guardarFactura() {
            if (!this.$refs.form.validate()) {
                return;
            }
            try {
                const request = {
                    id_proyecto: this.id_proyecto,
                    id_retencion: this.id_retencion,
                    // total: this.calcula_total(),
                    total: this.total,
                    descuento: this.desc,
                    fecha: this.fecha,
                    id_cuenta: this.cuenta,
                    items_factura: this.items,
                    status_iva: this.incl_iva,
                    nro_factura: this.nro_factura,
                    tipo: this.tipo,
                    id_cliente: this.id_cliente,
                    nombre_cliente: this.nombre_cliente,
                    cif_cliente: this.cif_cliente,
                    domicilio: this.domicilio,
                    notas: this.notas,
                    kit: this.kit,
                    enviado: this.enviado_cliente,
                };
                // console.log("******datat*****", request);
                if (this.$route.query.id) {
                    // Editar
                    await axios.post(
                        "api/update-facturas/" + this.$route.query.id,
                        request
                    );
                    // Eliminar items
                    if (this.id_items_factura.length > 0) {
                        const request_item = {
                            id_items_factura: this.id_items_factura,
                        };
                        await axios.post("api/delete-items-facturas", request);
                    }
                    this.$toast.sucs("Editado con exito");
                } else {
                    // Registro
                    const res = await axios.post("api/store-facturas", request);
                    this.$router.push(
                        `${this.$route.meta.form}?id=${res.data.id}`
                    );
                    this.$router.go();
                    this.$toast.sucs("Registrado con éxito");
                }

                if (this.$route.meta.name == "facturas") {
                    this.dialog_proyectos = true;
                }

                this.guardado = this.enviado_cliente ? true : false;
            } catch (error) {
                const error_data = Object.values(error.response.data.error);
                const msg_error = error_data.flat();
                console.log(msg_error);
                let lt = `<ul>`;
                for (const iterator of msg_error) {
                    lt = lt + `<li>${iterator}</li>`;
                }
                lt = lt + `</ul>`;
                this.$toast.error("Error guardando la factura" + lt);
            }
        },
        ChangeFactura() {
            axios
                .post(`api/change-factura-type`, {
                    id: this.$route.query.id,
                    tipo: 1,
                })
                .then(
                    (res) => {
                        this.$router.push(`/registrr-facturas?id=${this.id}`);
                    },
                    (res) => {}
                );
        },
        duplicarFactura() {
            axios
                .get(
                    `api/duplicar-factura/${this.$route.query.id}/${this.tipo}`
                )
                .then((res) => {
                    this.$router.push(`/registrr-facturas?id=${this.id}`);
                });
        },

        // Agregar servicio a facturar
        HandlerAdd() {
            if (
                this.description != "" &&
                this.quantity != "" &&
                this.price != "" &&
                this.imp != "" &&
                this.id_iva != null
            ) {
                const item = {
                    descripcion: this.description,
                    cantidad: this.quantity,
                    precio: this.price,
                    importe: this.imp,
                    id_iva: this.id_iva,
                    id: Date.now() + "a",
                };
                if (this.editing != null) {
                    const linea = this.items.find((ele) => ele == this.editing);
                    const index = this.items.findIndex(
                        (ele) => ele == this.editing
                    );

                    linea.descripcion = item.descripcion;
                    linea.cantidad = item.cantidad;
                    linea.precio = item.precio;
                    linea.importe = item.importe;
                    linea.id_iva = item.id_iva;
                    this.items[index] = linea;
                } else {
                    this.items.push(item);
                }
                this.LimpiarServicio();
                this.calcularTotales();
            }
        },
        editItem(item) {
            this.editing = item;
            let elemento_data = JSON.parse(JSON.stringify(item));

            this.description = elemento_data.descripcion;
            this.quantity = elemento_data.cantidad;
            this.price = elemento_data.precio;
            this.imp = elemento_data.importe;
            this.id = elemento_data.id;
            this.id_iva = elemento_data.id_iva;

            //this.deleteItem(item);
        },
        deleteItem(item) {
            const search = this.items.indexOf(item);
            if (search > -1) {
                this.items.splice(search, 1);
            }
        },
        LimpiarServicio() {
            this.editing = null;
            this.id = Date.now() + "a";
            this.description = "";
            this.quantity = "";
            this.price = "";
            this.imp = "";
            this.id_iva = null;
        },

        // Metodos generales
        getAllCuentas() {
            axios.get(`api/get-cuentas-banco`).then(
                (res) => {
                    this.cuentas = res.data;
                },
                (res) => {
                    this.$toast.error("Error consultando Cuentas Bancarias");
                }
            );
        },
        getActiveClientes() {
            let url = `api/get-all-clientes-active-proyectos`;
            if (this.$route.meta.name != "facturas")
                url = "api/get-all-clientes?potencial=true";
            axios.get(url).then(
                (res) => {
                    if (this.$route.meta.name != "facturas") {
                        this.usuarios = res.data;
                    } else {
                        this.usuarios = res.data.users;
                    }
                    for (let i = 0; i < this.usuarios.length; i++) {
                        const element = this.usuarios[i];
                        element.created_at = new Date(
                            element.created_at
                        ).toLocaleDateString();
                    }

                    console.log("usuarios aqui", this.usuarios);
                },
                (err) => {
                    this.$toast.error("Error consultando Usuario");
                }
            );
        },
        getRetenciones() {
            axios.get(`api/retenciones`).then((res) => {
                this.retenciones = res.data;
            });
        },
        getIvas() {
            axios.get(`api/iva`).then((res) => {
                this.ivas = res.data;
            });
        },
        async getProyectoById(proyecto_id) {
            try {
                const response = await axios.get(
                    `api/get-proyecto-by-id/${proyecto_id}`
                );

                // Filtrar solo los gastos que son suplidos
                const gastosSuplidos = response.data.gastos_externos.filter(
                    (gasto) => gasto.suplidos == true
                );

                if (gastosSuplidos.length > 0) {
                    this.gastos_externos = gastosSuplidos;
                    this.isAlertDialogVisible = true;
                }
            } catch (error) {
                console.log(error);
            }
        },

        // Agregar, editar y eliminar retenciones
        createRetencion() {
            axios.post("api/retencion", this.retencion).then(
                (res) => {
                    this.getRetenciones();
                },
                (res) => {}
            );
        },
        updateRetencion() {
            // console.log(this.estado);
            axios
                .put(`api/retencion/${this.retencion.id}`, this.retencion)
                .then(
                    (res) => {
                        this.getRetenciones();
                    },
                    (res) => {}
                );
        },
        updateRetencionS(index) {
            this.retencion = this.retenciones[index];
        },
        deleteRetencion(id) {
            axios.delete(`api/retencion/${id}`).then(
                (res) => {
                    this.getRetenciones();
                    this.retencion.id = null;
                },
                (res) => {}
            );
        },

        // Busca los proyectos del usuario/cliente seleccionado
        async getProyectosByUser(userId, tipo) {
            try {
                const res = await axios.get(
                    `api/get-proyectos-by-user-id/${userId}/${tipo}`
                );
                this.proyectos = res.data;
                if (this.$route.query.proyecto != undefined) {
                    this.id_proyecto = parseInt(this.$route.query.id_proyecto);
                }
            } catch (e) {
                this.$toast.error("Error consultando proyectos");
            }
            // axios.get(`api/get-proyectos-by-user-id/${userId}/${tipo}`).then(
            //     (res) => {
            //         this.proyectos = res.data;
            //         if (this.$route.query.proyecto != undefined) {
            //             this.id_proyecto = parseInt(this.$route.query.proyecto);
            //         }
            //     },
            //     (res) => {
            //         this.$toast.error("Error consultando proyectos");
            //     }
            // );
        },
        getCliente() {
            console.log("usuarios", this.usuarios);

            if (this.usuarios.length > 0) {
                this.cliente = this.usuarios.find(
                    (element) => element.id == this.id_cliente
                );
            }

            console.log("cliente", this.cliente);

            let provincia = "";
            if (this.cliente.provincia != null) {
                provincia = this.cliente.provincia.nombre;
            }

            const domicilio =
                (this.cliente.direccion ?? "") +
                (this.cliente.codigo_postal != null ? "-- C.P." : "") +
                (this.cliente.codigo_postal ?? "") +
                " " +
                (this.cliente.localidad ?? "") +
                " " +
                provincia;

            // Si factura.id (route.query.id) es null entonces establecer los valores de nombre, cif y domicilio
            // de cliente segun el cliente seleccionado
            if (!this.$route.query.id) {
                this.nombre_cliente = this.cliente.nombre_fiscal;
                this.cif_cliente = this.cliente.cif;
                this.domicilio = domicilio;
            }
        },

        // Metodos auxiliares
        subTotal() {
            const total = this.items.reduce((acc, arr) => {
                acc = parseFloat(acc) + parseFloat(arr.importe);
                acc = parseFloat(acc).toFixed(2);
                return acc;
            }, 0);
            return total;
        },
        descuento() {
            let descuentoNeto = (this.subTotal() * this.desc) / 100;
            return descuentoNeto;
        },
        HandlerRetencion() {
            const subtotal = parseFloat(this.subTotal()).toFixed(2);
            const dcto = parseFloat(this.descuento()).toFixed(2);
            const base = subtotal - dcto;
            const retencion = this.retenciones.find(
                (ret) => ret.id == this.id_retencion
            );
            const importe_retencion = (base * retencion?.descripcion) / 100;
            return isNaN(importe_retencion) ? 0 : importe_retencion;
        },
        calcularTotales() {
            // Objeto para almacenar los totales de IVA
            let totalesIva = {};
            this.items.forEach((element) => {
                let iva = this.ivas.find(
                    (iva) => iva.id == element.id_iva
                ).descripcion;
                let subtotal = element.cantidad * element.precio;
                // let dcto = (subtotal * element.dcto) / 100;
                // subtotal = subtotal - dcto;
                let iva_valor = (subtotal * iva) / 100;

                // Verificar si ya existe un total de IVA para el tipo de IVA actual
                if (totalesIva.hasOwnProperty(iva)) {
                    // Si existe, sumar al total existente
                    totalesIva[iva] += iva_valor;
                } else {
                    // Si no existe, crear un nuevo total de IVA para el tipo de IVA actual
                    totalesIva[iva] = iva_valor;
                }
            });
            // Convertir los totales de IVA de nuevo a un array de objetos
            this.totales_ivas = Object.keys(totalesIva).map((iva) => {
                return {
                    titulo: `IVA ${iva}%`,
                    value: totalesIva[iva],
                    iva: parseInt(iva),
                };
            });

            // Calcular total final
            const subtotal = this.subTotal();
            const descuento = this.descuento();
            const retencion = this.HandlerRetencion();
            const ivasTotal = this.totales_ivas.reduce(
                (acc, iva) => acc + iva.value,
                0
            );

            this.total = subtotal - descuento - retencion + ivasTotal;
        },

        // En desuso
        /*HandlerIva(calculatotal) {
            if (this.incl_iva == true) {
                const number =
                    parseFloat(this.subTotal()).toFixed(2) -
                    parseFloat(this.descuento()).toFixed(2);
                const mult = (number * 21) / 100;
                this.iva = mult;
                let ivacalc = parseFloat(mult).toFixed(2);
                if (calculatotal) {
                    this.calcula_total();
                }
                return mult;
            } else {
                this.iva = 0;
                if (calculatotal) {
                    this.calcula_total();
                }
                return 0;
            }
        },calcula_total() {
            let subtotal = this.subTotal();
            subtotal = parseFloat(subtotal).toFixed(2);
            let descuento = this.descuento();
            descuento = parseFloat(descuento).toFixed(2);
            // let iva = this.HandlerIva(false);
            let retencion = this.HandlerRetencion();

            this.total = subtotal - descuento;
            this.total = this.total - retencion;
            this.total =
                this.total +
                this.totales_ivas.reduce((acc, iva) => acc + iva.value, 0);
            return this.total;
        },
        edit(item) {
            this.description = item.description;
            this.quantity = item.quantity;
            this.price = item.price;
            this.imp = item.imp;
        },
        async getAllProyectos() {
            try {
                const response = await axios.get(`api/get-all-proyectos`);
                this.proyectos = response.data.filter(
                    (index) => index.usuario !== null
                );
                if (this.$route.query.proyecto != undefined) {
                    this.id_proyecto = parseInt(this.$route.query.proyecto);
                }
            } catch (error) {
                console.log(error);
            }
        },*/
    },
};
</script>
<style>
.pre-wrap {
    white-space: pre-wrap;
}
.w-6 {
    width: 2rem;
    height: 2rem;
    color: white;
}
</style>
